import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { EBaseUrl } from "index";
import thunkOptions from "store/config/thunkOptions";
import {
    IDashboardData,
    IDashboardDataRequest,
    IDashboardState,
    IDeliveredData,
    IDeliveredDataRequest, IGetDashboardGroupbyFilter,
} from "store/interfaces/dashboard";
import { IState } from "store/interfaces/main";
import { api } from "store/services/apiService";

const name = "DASHBOARD";

const initialState: IDashboardState = {
  deliveredData: null,
  dashboardData: null,
};

export const GetSurveyDeliveredData = createAsyncThunk<
  IDeliveredData,
  IDeliveredDataRequest
>(
  `${name}/GetSurveyDeliveredData`,
  async (formData) => {
    return (await api.post(`${EBaseUrl.API}/Dashboard/Delivered`, formData))
      .data;
  },
  thunkOptions
);

export const GetDashboardData = createAsyncThunk<
  IDashboardData,
  IDashboardDataRequest
>(
  `${name}/GetDashboardData`,
  async (formData) => {
    return (await api.post(`${EBaseUrl.API}/Dashboard/Data`, formData)).data;
  },
  thunkOptions
);

export const GetDashboardGroupbyFilter = createAsyncThunk<
    IDashboardDataRequest,
    string
>(
    `${name}/GetDashboardGroupbyFilter`,
    async (term: string) => {
        const response = await api.post(
            `${EBaseUrl.API}/Dashboard/GroupbyFilter`,
            null,
            {
                params: {
                    filter: "campaignname",
                    term,
                    count: 10,
                },
            }
        );

        return response.data;
    },
    thunkOptions
);

export const ExportStatistics = createAsyncThunk<
  string,
  { params: string; body?: any }
>(
  `${name}/ExportStatistics`,
  async ({ params, body }: { params: string; body?: any }) => {
    return await api.post(
      `${EBaseUrl.API}/Dashboard/Export?${params}`,
      { body },
      {
        responseType: "blob",
      }
    );
  }
);

export const ExportStatisticsAll = createAsyncThunk<
  string,
  { params: string; body?: any }
>(
  `${name}/ExportStatistics`,
  async ({ params, body }: { params: string; body?: any }) => {
    return await api.post(
      `${EBaseUrl.API}/Dashboard/ExportAll?${params}`,
      { body },
      {
        responseType: "blob",
      }
    );
  }
);

export const RunAssistDashboard = createAsyncThunk<
  string,
  { question: string }
>(`${name}/ExportStatistics`, async (data) => {
  return await api.post(`${EBaseUrl.API}/Assist/Run`, data);
});

const dashboardSlice = createSlice({
  initialState,
  name,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetSurveyDeliveredData.fulfilled, (state, { payload }) => {
      state.deliveredData = payload;
    });
    builder.addCase(GetDashboardData.fulfilled, (state, { payload }) => {
      state.dashboardData = payload;
    });
  },
});

export const selectDeliveredData = (state: IState) =>
  state.dashboard.deliveredData;
export const selectDashboardData = (state: IState) =>
  state.dashboard.dashboardData;

export default dashboardSlice.reducer;
